import type { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { ToastContainer } from '../ui/Toast';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen">
      {/* Background blobs */}
      <div className="blob-blue" />
      <div className="blob-orange" />
      <div className="blob-dark" />

      <Sidebar />

      {/* Main content area — offset for sidebar on desktop */}
      <div className="lg:ml-[280px] relative z-10 flex min-h-screen flex-col">
        <Header />
        <main className="flex-1 p-4 lg:p-6">{children}</main>
      </div>

      <ToastContainer />
    </div>
  );
}
